import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

function WhistleBlowing() {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <Helmet>
        <title>Whistleblowing</title>

      </Helmet>
      <section className="w-full bg-white">
        <div className="max-w-4xl mx-auto py-36 px-5 text-black text-start">
          <h1 className="text-3xl font-bold text-center mb-10">Segnalazioni Whistleblowing</h1>
          <div>
            <p className="pb-5 ">
              Careisgold Spa invita tutti i propri dipendenti, collaboratori, business partner e stakeholders più in generale a far sentire la propria voce nel caso di situazioni di illiceità, cui dovessero assistere o di cui possano essere venuti a conoscenza.
            </p>
            <p className="pb-5 ">
              Il <b>whistleblowing</b> è un modo per segnalare comportamenti scorretti o illegali che potrebbero danneggiare la nostra azienda. Questi comportamenti potrebbero includere violazioni del nostro Codice Etico, delle nostre procedure interne o di qualsiasi altra norma applicabile.
            </p>
            <p className="pb-5 ">
              Le segnalazioni devono essere basate su fatti concreti o irregolarità. Per irregolarità si intendono quegli elementi sintomatici di potenziali violazioni che, pur non costituendo ancora un illecito conclamato, rappresentano indici ragionevoli del fatto che una violazione potrebbe essere commessa. Careisgold Spa ha predisposto una piattaforma dedicata per l’invio di Segnalazioni, idonea a garantire la riservatezza.

              Le segnalazioni, inoltre, devono essere inviate in buona fede.
            </p>
            <p className="pb-5 ">
              Tale piattaforma è raggiungibile dall’indirizzo <Link to="https://careisgold-whistleblowing.go-tell.it/" target="_blank" rel="noopener noreferrer" className="text-blue-600">https://careisgold-whistleblowing.go-tell.it/</Link> e permette di inviare segnalazioni puntuali senza necessità di creare account.
            </p>
            <div>
              <p className="pt-5 pb-3 font-bold">
                Gestione della segnalazione
              </p>
              <ul className="space-y-5">
                <li>
                  <p className="mb-2">
                    1. <b>Ricezione della segnalazione</b>
                  </p>
                  <p>
                    All’atto della ricezione di una Segnalazione, indipendentemente dal canale utilizzato, il Gestore delle Segnalazioni provvederà ad attribuire un numero identificativo progressivo che ne consentirà l’identificazione univoca.
                  </p>
                </li>
                <li>
                  <p className="mb-2">
                    2. <b>Analisi e valutazione preliminare</b>
                  </p>
                  <p>
                    Il Gestore delle Segnalazioni provvede tempestivamente alla presa in carico e all’analisi della Segnalazione ricevuta, al fine della sua valutazione preliminare.

                    A seguito di questa analisi, il Gestore delle Segnalazioni provvederà a classificare la Segnalazione in una delle categorie, che implicheranno un diverso e specifico flusso.
                  </p>
                </li>
                <li>
                  <p className="mb-2">
                    3. <b>Indagini</b>
                  </p>
                  <p>
                   Al termine della fase di valutazione preliminare, se la Segnalazione ricevuta viene classificata come “rilevante e trattabile”, il Gestore delle Segnalazioni procederà con l’avvio delle verifiche e indagini interne al fine di raccogliere ulteriori informazioni di dettaglio per verificare la fondatezza dei fatti segnalati e raccoglierne adeguata evidenza.
                  </p>
                </li>
              </ul>
              <a 
                href="/pdf/Informativa_segnalanti_facilitatori_CIG_Go-Tell.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline block mt-4"
              >
                Clicca qui per scaricare l'informativa
              </a>
            </div>


          </div>

        </div>
      </section>
    </>
  );
}

export default WhistleBlowing;
